import GatewayContainer from '../config/GatewayContainer';
import GatewayNames from '../constant/GatewayNames';
import { BackgroundJob, WritableBackgroundJob } from '../domain/job/JobDomain';
import JobClient from '../client/job/JobClient';
import { query } from '@trlogic/client-js';
import Query = query.Query;
import MessageUtil from '../util/MessageUtil';
import LanguageUtil from '../util/LanguageUtil';

class JobService {
  private readonly jobClient: JobClient = GatewayContainer.getInstance().get(GatewayNames.JOB_CLIENT);

  public async schedule(job: BackgroundJob) {
    try {
      await this.jobClient.schedule(job);
    } catch (e) {
      console.error(e);
    }
  }

  public async download(id: string, job?: BackgroundJob) {
    try {
      const file: Blob | undefined = await this.jobClient.download(id);
      const url = window.URL.createObjectURL(file as Blob);
      const a = document.createElement('a');
      a.href = url;
      
      let fileExtension = 'csv';
      if (job) {
        const writableJob = job as Partial<WritableBackgroundJob>;
        if (writableJob.extension && typeof writableJob.extension === 'string') {
          fileExtension = writableJob.extension;
        } else if (writableJob.path && typeof writableJob.path === 'string') {
          const pathParts = writableJob.path.split('.');
          if (pathParts.length > 1) {
            fileExtension = pathParts[pathParts.length - 1].toLowerCase();
          }
        }
      }
      
      a.download = `${id}.${fileExtension}`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (e) {}
  }

  public async getCount(query: Query): Promise<number> {
    return this.jobClient.count(query);
  }

  public async findMany(query: Query): Promise<BackgroundJob[]> {
    return this.jobClient.findMany(query);
  }

  public async delete(id: string) {
    try {
      await this.jobClient.delete(id);
      MessageUtil.deleteMessage(LanguageUtil.get({ id: 'messages.success.jobDeleted', defaultMessage: 'Job deleted successfully!' }));
    } catch (e) {
      MessageUtil.showError(LanguageUtil.get({ id: 'messages.failed.jobDeleted', defaultMessage: 'Job delete failed!' }));
    }
  }
}

export default JobService;
